// import React, { useState } from "react";
// import "./Services.css";

// const servicesData = [
//   {
//     name: "Hair Styling",
//     subServices: [
//       { name: "Hair Cut", price: "₹500", img: "https://www.fabmood.com/wp-content/uploads/2024/06/Glamorous-U-Shaped-Layer-with-Soft-Volume.jpg" },
//       { name: "Hair Color", price: "₹1200", img: "https://www.shutterstock.com/image-photo/ombre-bob-short-hairstyle-beautiful-260nw-795082447.jpg" },
//       { name: "Hair Treatment", price: "₹1500", img: "https://cdn.shopify.com/s/files/1/0532/0998/9283/files/What_Is_Nanoplastia_Hair_Treatment_480x480.jpg?v=1739961442" },
//       { name: "Blow Dry", price: "₹700", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4NgsC85iB6Mi0pLyuv-fmhQ9WIqJEvytl-A&s" },
//       { name: "Keratin Treatment", price: "₹3000", img: "https://kerafinekf.com/wp-content/uploads/2024/03/KERATIN-TREAMENT-250-ML-4.png" },
//       { name: "Layered Cut", price: "₹600", img: "https://content.latest-hairstyles.com/wp-content/uploads/layers-for-a-u-shaped-cut.jpg" },
//       { name: "Perming", price: "₹2500", img: "https://www.stylecraze.com/wp-content/uploads/2013/01/iStock-497344296_1200px.jpg.webp" },
//       { name: "Scalp Massage", price: "₹400", img: "https://holistichair.co.nz/cdn/shop/articles/AdobeStock_265251848__Dark_Haird_woman_healthy_scalp_1600x.jpg?v=1759894840" },
//       { name: "Updo Styling", price: "₹1000", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAQIxx5osPy6GqRVtzTymyHv4nIuHd7YQXpg&s" },
//       { name: "Hair Spa", price: "₹1200", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgNyec9xX5WkE5_2j9lKFzPuUk5Rz2R4W-cA&s" },
//     ],
//   },
//   {
//  name: "Makeup",
//     subServices: [
//       { name: "HD Bridal Makeup", price: "₹7999", img: "https://www.wedium.com/wp-content/uploads/2019/10/bridal-makeup-artist-in-bhubaneswar.jpg" },
//       { name: "Airbrush Bridal", price: "₹9999", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLbaqbdOYKiro-83mqbuswKEp2IhGrEAdxNg&s" },
//       { name: "Traditional Look", price: "₹6999", img: "https://5.imimg.com/data5/SELLER/Default/2022/8/BC/IT/RJ/18451800/traditional-look-soft-silk-saree-with-blouse.jpeg" },
//       { name: "Engagement Look", price: "₹4999", img: "https://i.pinimg.com/736x/9e/02/00/9e0200db532e207fc462f27a47f0c735.jpg" },
//       { name: "Reception Makeup", price: "₹6999", img: "https://assets.vogue.in/photos/5d2c4967e2f0130008fa5e34/16:9/w_3103,h_1745,c_limit/Anushka%20Sharma%20Virat%20Kohli%20wedding%20reception%20Sabyasachi%20sari%201.jpg" },
//       { name: "Party Makeup", price: "₹3999", img: "https://st3.depositphotos.com/2947157/18525/i/450/depositphotos_185251124-stock-photo-beautiful-woman-with-professional-make.jpg" },
//       { name: "Pre-wedding Makeup", price: "₹5999", img: "https://cdn.shopify.com/s/files/1/0529/0619/7148/files/3_nude_480x480.jpg" },
//       { name: "Haldi Look", price: "₹3499", img: "https://cdn.pixabay.com/photo/2017/08/06/10/19/makeup-2594226_1280.jpg" },
//       { name: "Sangeet Makeup", price: "₹4499", img: "https://cdn.pixabay.com/photo/2016/11/29/09/36/makeup-1867099_1280.jpg" },
//       { name: "Bridesmaid Makeup", price: "₹2999", img: "https://cdn.pixabay.com/photo/2016/11/29/09/30/makeup-1867095_1280.jpg" },
//     ],
//   },
  
//   {
//     name: "Manicure",
//     subServices:  [
//   { name: "Classic Manicure", price: "₹499", img: "https://i.etsystatic.com/15032115/r/il/c19381/2227799795/il_570xN.2227799795_bhqs.jpg" },
//   { name: "French Manicure", price: "₹599", img: "https://i.pinimg.com/736x/b4/80/05/b4800546ec7cd7fecc3a90dfc4eb1dfe.jpg" },
//   { name: "Gel Manicure", price: "₹799", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUSHdm8R43el3266B9laNGeEP7jO8LQ0ERLw&s" },
//   { name: "Spa Manicure", price: "₹699", img: "https://www.bodycraft.co.in/hs-fs/hubfs/Imported_Blog_Media/manicurist-master-makes-manicure-woman-s-hands-spa-treatment-concept-1.jpg?width=601&height=451&name=manicurist-master-makes-manicure-woman-s-hands-spa-treatment-concept-1.jpg" },
//   { name: "Acrylic Manicure", price: "₹899", img: "https://cdn.shopify.com/s/files/1/0616/4217/8742/files/what_is_acrylic_nail_image_03_1024x1024.webp?v=1730119290" },
//   { name: "Gel Polish", price: "₹749", img: "https://m.media-amazon.com/images/I/71nWDfur6wL._UF350,350_QL80_.jpg" },
//   { name: "Deluxe Manicure", price: "₹999", img: "https://balancedayspa.com/cdn/shop/files/deluxemanicure_4480x.webp?v=1738369181" },
//   { name: "Matte Finish", price: "₹699", img: "https://hips.hearstapps.com/hmg-prod/images/matte-black-nails-641876fa4ee14.png?crop=0.500xw:0.994xh;0,0.00637xh&resize=1200:*" },
//   { name: "Nail Art Basic", price: "₹799", img: "https://i.ytimg.com/vi/XTxGPij59p4/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLA6fG5QHzqc9rOlkT2p0C5Q4nBx3A" },
//   { name: "Nail Art Premium", price: "₹1199", img: "https://alpsnailart.com/wp-content/uploads/2022/04/02E79FD9-2263-4D13-B1D8-5D6FE308A5E7.jpeg" },
// ],
//   },
//   {
//     name: "Pedicure",
//     subServices:[
//   { name: "Classic Pedicure", price: "₹499", img: "https://spongelle.com/cdn/shop/articles/pedicure-types.jpg?v=1689702966" },
//   { name: "French Pedicure", price: "₹599", img: "https://cdn2.stylecraze.com/wp-content/uploads/2014/07/How-To-Do-A-French-Pedicure-At-Home-10-Easy-Steps-And-Tips.jpg.webp" },
//   { name: "Gel Pedicure", price: "₹799", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8hraSwRCro3xbjsg5D0CiEtXw3qLXfLLNIg&s" },
//   { name: "Spa Pedicure", price: "₹699", img: "https://img.freepik.com/free-photo/spa-treatment-product-female-feet-hand-spa_1150-37700.jpg?semt=ais_hybrid&w=740&q=80" },
//   { name: "Acrylic Pedicure", price: "₹899", img: "https://i.ytimg.com/vi/NpCE1q7eDGI/sddefault.jpg" },
//   { name: "Deluxe Pedicure", price: "₹999", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRemEgVk5-zo4u-EYgDWesX_1kNZzuf7OdR3w&s" },
//   { name: "Matte Finish Pedicure", price: "₹699", img: "https://i.pinimg.com/564x/d3/b9/76/d3b97604550751c11a25e3aee6e9f4d2.jpg" },
//   { name: "Nail Art Pedicure", price: "₹799", img: "https://i.ytimg.com/vi/AKzhsXwZ0cY/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLBcJFCO0qa4JY4aJsS4AfCf3eXbvw" },
//   { name: "Luxury Spa Pedicure", price: "₹1199", img: "https://img1.wsimg.com/isteam/ip/d9030a45-d799-4ccb-8a20-30f5a28a4d0c/IMG_1971.jpeg/:/cr=t:25%25,l:0%25,w:100%25,h:75%25/rs=w:1240,h:1240,cg:true" },
//   { name: "Herbal Pedicure", price: "₹899", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWKIAkd3QslGdip4IURoDCiSxfpSSVy-WB1g&s" },
// ],
//   },
//   {
//     name: "Massage",
//     subServices:  [
//   { name: "Swedish Massage", price: "₹600", img: "https://www.worldsprings.com/_next/image?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2Fqcr4yifs%2Fproduction%2F7b68a8c8f761a63290d5f423afb67f8f4c853bf4-2000x1545.jpg%3Fw%3D1536%26fit%3Dcrop%26auto%3Dformat&w=1536&q=75" },
//   { name: "Deep Tissue Massage", price: "₹1000", img: "https://images.squarespace-cdn.com/content/v1/5f2864b6ee63644ee0b157d3/1724694633011-SJLESBYMV1Y4CDQ4T7CK/deep+tissue+massage+techniques+for+beginners.jpg" },
//   { name: "Aromatherapy Massage", price: "₹1200", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgaZvYPk2ycm12nkmQ10zA-u-0O3fjEGineA&s"},
//   { name: "Hot Stone Massage", price: "₹1500", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQimxcf6b4GQxBnfA9qMJEoWnkvPUgRkHICcg&s" },
//   { name: "Thai Massage", price: "₹1300", img: "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/12/32/f4/c0.jpg" },
//   { name: "Leg Massage", price: "₹1400", img: "https://static.wixstatic.com/media/632721_fbe43cdf36f74c3492678ff8fd233ef9~mv2.jpg/v1/fill/w_640,h_442,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_auto/632721_fbe43cdf36f74c3492678ff8fd233ef9~mv2.jpg" },
//   { name: "Mouth Massage", price: "₹1100", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1aQ09ZNyg4r-eWYAqY4_-cofcK7CCUhjUJQ&s" },
//   { name: "Shiatsu Massage", price: "₹1250", img: "https://images.squarespace-cdn.com/content/v1/5f2864b6ee63644ee0b157d3/e22757d5-8af3-440b-a4c5-830c58eaf28e/Shiatsu+Massage.jpg"},
//   { name: "Couple Massage", price: "₹2000", img: "https://cdn.pixabay.com/photo/2017/08/06/10/21/massage-2594229_1280.jpg" },
//   { name: "Head & Shoulder Massage", price: "₹900", img:"https://images.squarespace-cdn.com/content/v1/5f2864b6ee63644ee0b157d3/e22757d5-8af3-440b-a4c5-830c58eaf28e/Shiatsu+Massage.jpg"},
// ],
//   },

//   {
//     name: "Threading",
//     subServices:[
//   { name: "Eyebrow Threading", price: "₹200", img: "https://cdn2.stylecraze.com/wp-content/uploads/2013/04/How-To-Thread-Eyebrows-%E2%80%93-A-Step-By-Step-Tutorial.jpg.webp" },
//   { name: "Upper Lip Threading", price: "₹150", img: "https://diaminyaesthetics.com/cdn/shop/articles/upper_lip_threading_58430868-e344-4217-ae07-d6193aa989aa.jpg?v=1743499657" },
//   { name: "Chin Threading", price: "₹150", img: "https://productimages.withfloats.com/serviceimages/tile/66cc54ec84783beac5ce657bChinthreading-01" },
//   { name: "Full Face Threading", price: "₹500", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZrRcDdYzjZmERggkc9o7wMZBGopECiHhBbw&s" },
//   { name: "Eyebrow Shaping", price: "₹250", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5R2rJo5byWBFaH7Poi0N_MHoyJ5FgsfsmdA&s" },
//   { name: "Sideburn Threading", price: "₹150", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRH_0FEMqNvKvCmqwlhDqM1wTphSeMrkeYGCA&s" },
//   { name: "Neck Threading", price: "₹200", img: "https://www.desertbloomskincare.com/wp-content/uploads/2022/12/AnyConv.com__4eb5096974-e1675782046597.jpg" },
//   { name: "Eyebrow Tint & Thread", price: "₹400", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEbKLFYkR9FrVreISoq0h9Nnem3AhMN4mzjg&s" },
//   { name: "Upper Lip & Chin Combo", price: "₹300", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPTsV2UGl4-Uf1aryWtZWYLlnU8LNQWHHtFw&s" },
//     ],
//   },
//   {
//     name: "Waxing",
//     subServices:[
//   { name: "Full Leg Wax", price: "₹700", img: "https://sumansalon.in/wp-content/uploads/2024/02/5475-2022-11-16.jpg" },
//   { name: "Half Leg Wax", price: "₹400", img: "https://5.imimg.com/data5/OU/PL/GLADMIN-32202639/suger-half-leg-waxing-service-500x500.png" },
//   { name: "Full Arm Wax", price: "₹500", img: "https://www.personasalon.co.in/wp-content/uploads/2020/05/Full-Arm-Waxing-ua.jpg" },
//   { name: "Half Arm Wax", price: "₹300", img: "https://www.personasalon.co.in/wp-content/uploads/2020/05/arms-waxing.jpg" },
//   { name: "Underarm Wax", price: "₹250", img: "https://divabeauty.co.nz/cdn/shop/files/underarmwax.jpg?v=1691046373" },
//   { name: "Back Wax", price: "₹800", img: "https://purespauk.com/cdn/shop/products/backwax.jpg?v=1634826122&width=1080" },
//   { name: "Chest Wax", price: "₹750", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWx5EngD7p0BI-ANn4c0vsDTYfgVAP1kVmQg&s" },
 
//   { name: "Full Body Wax", price: "₹2500", img: "https://faithandpatience.co.in/cdn/shop/articles/7_189f99ce-2af3-4284-a4b2-fe3e971bf942.jpg?v=1753866497&width=1920"},
//   { name: "Eyebrow Wax", price: "₹200", img: "https://productimages.withfloats.com/actual/662c70094a71d04d70504c41.jpg" },
// ],
//   },
//   {
//     name: "Skin Treatment",
//     subServices:  [
//   { name: "Acne Treatment", price: "₹1500", img: "https://www.cozmoderm.com/wp-content/uploads/2022/06/Acne-1.jpeg" },
//   { name: "Anti-Aging Treatment", price: "₹2500", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxgS1wslb_V5FKV8XTCpAl2xSIOSCKGGp1hA&s" },
//   { name: "Glow Facial", price: "₹1200", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-p2Y3r8J0EFbYPWnwhxL8VXWSdUA_ck3hHA&s" },
//   { name: "Hydrating Facial", price: "₹1000", img: "https://irp-cdn.multiscreensite.com/698c692a/dms3rep/multi/Benefits-of-a-Hydrating-Facial.png" },
//   { name: "Vitamin C Facial", price: "₹1300", img: "https://d2p5rd30inmhrb.cloudfront.net/m2/media/catalog/product/gallery/resized/webp2/vitamincc_2.webp" },
//   { name: "Deep Cleansing Facial", price: "₹1100", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFsUvYlxP6HazicSF00lU5QY0QTv7YJk_ArQ&s" },
//   { name: "Brightening Treatment", price: "₹1400", img: "https://ladermaskinclinic.com/wp-content/webp-express/webp-images/uploads/2023/12/skin-1.jpg.webp" },
//   { name: "Laser Skin Treatment", price: "₹3000", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZHiKdd8CFjegIjVCw2G-wxgm8kDUJLGwiuQ&s" },
//   { name: "Pigmentation Treatment", price: "₹1800", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQniM_qjpzq_2otmbXCOSn8Yu71EzmGgcQLHA&s" },
//   { name: "Collagen Facial", price: "₹2000", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLcYfq6CXnIxTrmS0JJ1pyJjJtdsi9V2cF2g&s" },
// ],
//   },
// ];
// export default function Services() {
//   const [activeService, setActiveService] = useState(0);

//   return (
//     <div className="services-page">
//       {/* Main Navbar */}
//       <nav className="main-navbar">
//         <span className="logo">MySalon</span>
//         <div className="nav-links">
//           <button>Home</button>
//           <button className="active-main">Services</button>
//           <button>Contact</button>
//         </div>
//       </nav>

//       {/* Services Navbar */}
//       <nav className="services-navbar">
//         {servicesData.map((service, idx) => (
//           <button
//             key={idx}
//             className={`service-btn ${activeService === idx ? "active" : ""}`}
//             onClick={() => setActiveService(idx)}
//           >
//             {service.name}
//           </button>
//         ))}
//         <div
//           className="underline"
//           style={{
//             transform: `translateX(${activeService * 120}px)`,
//           }}
//         />
//       </nav>

//       {/* Sub-services */}
//       <div className="sub-services">
//         <h2>{servicesData[activeService].name} Packages</h2>
//         <div className="sub-services-grid">
//           <div className="sub-services-scroll">
//             {servicesData[activeService].subServices
//               .concat(servicesData[activeService].subServices) // duplicate for infinite scroll
//               .map((sub, idx) => (
//                 <div key={idx} className="sub-service-card">
//                   <img src={sub.img} alt={sub.name} />
//                   <div className="sub-service-info">
//                     <h3>{sub.name}</h3>
//                     <p>{sub.price}</p>
//                   </div>
//                 </div>
//               ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import "./Services.css";

const servicesData = [
  // Hair Styling
  {
    name: "Hair Styling",
    subServices: [
      { name: "Hair Cut", price: "₹500", img: "https://www.fabmood.com/wp-content/uploads/2024/06/Glamorous-U-Shaped-Layer-with-Soft-Volume.jpg" },
      { name: "Hair Color", price: "₹1200", img: "https://www.shutterstock.com/image-photo/ombre-bob-short-hairstyle-beautiful-260nw-795082447.jpg" },
      { name: "Hair Treatment", price: "₹1500", img: "https://cdn.shopify.com/s/files/1/0532/0998/9283/files/What_Is_Nanoplastia_Hair_Treatment_480x480.jpg?v=1739961442" },
      { name: "Blow Dry", price: "₹700", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4NgsC85iB6Mi0pLyuv-fmhQ9WIqJEvytl-A&s" },
      { name: "Keratin Treatment", price: "₹3000", img: "https://kerafinekf.com/wp-content/uploads/2024/03/KERATIN-TREAMENT-250-ML-4.png" },
      { name: "Layered Cut", price: "₹600", img: "https://content.latest-hairstyles.com/wp-content/uploads/layers-for-a-u-shaped-cut.jpg" },
      { name: "Perming", price: "₹2500", img: "https://www.stylecraze.com/wp-content/uploads/2013/01/iStock-497344296_1200px.jpg.webp" },
      { name: "Scalp Massage", price: "₹400", img: "https://holistichair.co.nz/cdn/shop/articles/AdobeStock_265251848__Dark_Haird_woman_healthy_scalp_1600x.jpg?v=1759894840" },
      { name: "Updo Styling", price: "₹1000", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSAQIxx5osPy6GqRVtzTymyHv4nIuHd7YQXpg&s" },
      { name: "Hair Spa", price: "₹1200", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgNyec9xX5WkE5_2j9lKFzPuUk5Rz2R4W-cA&s" },
    ],
  },
  // Makeup
  {
    name: "Makeup",
    subServices: [
      { name: "HD Bridal Makeup", price: "₹7999", img: "https://www.wedium.com/wp-content/uploads/2019/10/bridal-makeup-artist-in-bhubaneswar.jpg" },
      { name: "Airbrush Bridal", price: "₹9999", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLbaqbdOYKiro-83mqbuswKEp2IhGrEAdxNg&s" },
      { name: "Traditional Look", price: "₹6999", img: "https://5.imimg.com/data5/SELLER/Default/2022/8/BC/IT/RJ/18451800/traditional-look-soft-silk-saree-with-blouse.jpeg" },
      { name: "Engagement Look", price: "₹4999", img: "https://i.pinimg.com/736x/9e/02/00/9e0200db532e207fc462f27a47f0c735.jpg" },
      { name: "Reception Makeup", price: "₹6999", img: "https://assets.vogue.in/photos/5d2c4967e2f0130008fa5e34/16:9/w_3103,h_1745,c_limit/Anushka%20Sharma%20Virat%20Kohli%20wedding%20reception%20Sabyasachi%20sari%201.jpg" },
      { name: "Party Makeup", price: "₹3999", img: "https://st3.depositphotos.com/2947157/18525/i/450/depositphotos_185251124-stock-photo-beautiful-woman-with-professional-make.jpg" },
      { name: "Pre-wedding Makeup", price: "₹5999", img: "https://cdn.shopify.com/s/files/1/0529/0619/7148/files/3_nude_480x480.jpg" },
      { name: "Haldi Look", price: "₹3499", img: "https://cdn.pixabay.com/photo/2017/08/06/10/19/makeup-2594226_1280.jpg" },
      { name: "Sangeet Makeup", price: "₹4499", img: "https://cdn.pixabay.com/photo/2016/11/29/09/36/makeup-1867099_1280.jpg" },
      { name: "Bridesmaid Makeup", price: "₹2999", img: "https://cdn.pixabay.com/photo/2016/11/29/09/30/makeup-1867095_1280.jpg" },
    ],
  },
  // Manicure
  {
    name: "Manicure",
    subServices: [
      { name: "Classic Manicure", price: "₹499", img: "https://i.etsystatic.com/15032115/r/il/c19381/2227799795/il_570xN.2227799795_bhqs.jpg" },
      { name: "French Manicure", price: "₹599", img: "https://i.pinimg.com/736x/b4/80/05/b4800546ec7cd7fecc3a90dfc4eb1dfe.jpg" },
      { name: "Gel Manicure", price: "₹799", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUSHdm8R43el3266B9laNGeEP7jO8LQ0ERLw&s" },
      { name: "Spa Manicure", price: "₹699", img: "https://www.bodycraft.co.in/hs-fs/hubfs/Imported_Blog_Media/manicurist-master-makes-manicure-woman-s-hands-spa-treatment-concept-1.jpg?width=601&height=451&name=manicurist-master-makes-manicure-woman-s-hands-spa-treatment-concept-1.jpg" },
      { name: "Acrylic Manicure", price: "₹899", img: "https://cdn.shopify.com/s/files/1/0616/4217/8742/files/what_is_acrylic_nail_image_03_1024x1024.webp?v=1730119290" },
      { name: "Gel Polish", price: "₹749", img: "https://m.media-amazon.com/images/I/71nWDfur6wL._UF350,350_QL80_.jpg" },
      { name: "Deluxe Manicure", price: "₹999", img: "https://balancedayspa.com/cdn/shop/files/deluxemanicure_4480x.webp?v=1738369181" },
      { name: "Matte Finish", price: "₹699", img: "https://hips.hearstapps.com/hmg-prod/images/matte-black-nails-641876fa4ee14.png?crop=0.500xw:0.994xh;0,0.00637xh&resize=1200:*" },
      { name: "Nail Art Basic", price: "₹799", img: "https://i.ytimg.com/vi/XTxGPij59p4/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLA6fG5QHzqc9rOlkT2p0C5Q4nBx3A" },
      { name: "Nail Art Premium", price: "₹1199", img: "https://alpsnailart.com/wp-content/uploads/2022/04/02E79FD9-2263-4D13-B1D8-5D6FE308A5E7.jpeg" },
    ],
  },
  // Pedicure
  {
    name: "Pedicure",
    subServices: [
      { name: "Classic Pedicure", price: "₹499", img: "https://spongelle.com/cdn/shop/articles/pedicure-types.jpg?v=1689702966" },
      { name: "French Pedicure", price: "₹599", img: "https://cdn2.stylecraze.com/wp-content/uploads/2014/07/How-To-Do-A-French-Pedicure-At-Home-10-Easy-Steps-And-Tips.jpg.webp" },
      { name: "Gel Pedicure", price: "₹799", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8hraSwRCro3xbjsg5D0CiEtXw3qLXfLLNIg&s" },
      { name: "Spa Pedicure", price: "₹699", img: "https://img.freepik.com/free-photo/spa-treatment-product-female-feet-hand-spa_1150-37700.jpg?semt=ais_hybrid&w=740&q=80" },
      { name: "Acrylic Pedicure", price: "₹899", img: "https://i.ytimg.com/vi/NpCE1q7eDGI/sddefault.jpg" },
      { name: "Deluxe Pedicure", price: "₹999", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRemEgVk5-zo4u-EYgDWesX_1kNZzuf7OdR3w&s" },
      { name: "Matte Finish Pedicure", price: "₹699", img: "https://i.pinimg.com/564x/d3/b9/76/d3b97604550751c11a25e3aee6e9f4d2.jpg" },
      { name: "Nail Art Pedicure", price: "₹799", img: "https://i.ytimg.com/vi/AKzhsXwZ0cY/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLBcJFCO0qa4JY4aJsS4AfCf3eXbvw" },
      { name: "Luxury Spa Pedicure", price: "₹1199", img: "https://img1.wsimg.com/isteam/ip/d9030a45-d799-4ccb-8a20-30f5a28a4d0c/IMG_1971.jpeg/:/cr=t:25%25,l:0%25,w:100%25,h:75%25/rs=w:1240,h:1240,cg:true" },
      { name: "Herbal Pedicure", price: "₹899", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWKIAkd3QslGdip4IURoDCiSxfpSSVy-WB1g&s" },
    ],
  },
  // Massage
  {
    name: "Massage",
    subServices: [
      { name: "Swedish Massage", price: "₹600", img: "https://www.worldsprings.com/_next/image?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2Fqcr4yifs%2Fproduction%2F7b68a8c8f761a63290d5f423afb67f8f4c853bf4-2000x1545.jpg%3Fw%3D1536%26fit%3Dcrop%26auto%3Dformat&w=1536&q=75" },
      { name: "Deep Tissue Massage", price: "₹1000", img: "https://images.squarespace-cdn.com/content/v1/5f2864b6ee63644ee0b157d3/1724694633011-SJLESBYMV1Y4CDQ4T7CK/deep+tissue+massage+techniques+for+beginners.jpg" },
      { name: "Aromatherapy Massage", price: "₹1200", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSgaZvYPk2ycm12nkmQ10zA-u-0O3fjEGineA&s"},
      { name: "Hot Stone Massage", price: "₹1500", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQimxcf6b4GQxBnfA9qMJEoWnkvPUgRkHICcg&s" },
      { name: "Thai Massage", price: "₹1300", img: "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/12/32/f4/c0.jpg" },
      { name: "Leg Massage", price: "₹1400", img: "https://static.wixstatic.com/media/632721_fbe43cdf36f74c3492678ff8fd233ef9~mv2.jpg/v1/fill/w_640,h_442,fp_0.50_0.50,q_80,usm_0.66_1.00_0.01,enc_auto/632721_fbe43cdf36f74c3492678ff8fd233ef9~mv2.jpg" },
      { name: "Mouth Massage", price: "₹1100", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1aQ09ZNyg4r-eWYAqY4_-cofcK7CCUhjUJQ&s" },
      { name: "Shiatsu Massage", price: "₹1250", img: "https://images.squarespace-cdn.com/content/v1/5f2864b6ee63644ee0b157d3/e22757d5-8af3-440b-a4c5-830c58eaf28e/Shiatsu+Massage.jpg"},
      { name: "Couple Massage", price: "₹2000", img: "https://cdn.pixabay.com/photo/2017/08/06/10/21/massage-2594229_1280.jpg" },
      { name: "Head & Shoulder Massage", price: "₹900", img:"https://images.squarespace-cdn.com/content/v1/5f2864b6ee63644ee0b157d3/e22757d5-8af3-440b-a4c5-830c58eaf28e/Shiatsu+Massage.jpg"},
    ],
  },
  // Threading
  {
    name: "Threading",
    subServices: [
      { name: "Eyebrow Threading", price: "₹200", img: "https://cdn2.stylecraze.com/wp-content/uploads/2013/04/How-To-Thread-Eyebrows-%E2%80%93-A-Step-By-Step-Tutorial.jpg.webp" },
      { name: "Upper Lip Threading", price: "₹150", img: "https://diaminyaesthetics.com/cdn/shop/articles/upper_lip_threading_58430868-e344-4217-ae07-d6193aa989aa.jpg?v=1743499657" },
      { name: "Chin Threading", price: "₹150", img: "https://productimages.withfloats.com/serviceimages/tile/66cc54ec84783beac5ce657bChinthreading-01" },
      { name: "Full Face Threading", price: "₹500", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZrRcDdYzjZmERggkc9o7wMZBGopECiHhBbw&s" },
      { name: "Eyebrow Shaping", price: "₹250", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5R2rJo5byWBFaH7Poi0N_MHoyJ5FgsfsmdA&s" },
      { name: "Sideburn Threading", price: "₹150", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRH_0FEMqNvKvCmqwlhDqM1wTphSeMrkeYGCA&s" },
      { name: "Neck Threading", price: "₹200", img: "https://www.desertbloomskincare.com/wp-content/uploads/2022/12/AnyConv.com__4eb5096974-e1675782046597.jpg" },
      { name: "Eyebrow Tint & Thread", price: "₹400", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEbKLFYkR9FrVreISoq0h9Nnem3AhMN4mzjg&s" },
      { name: "Upper Lip & Chin Combo", price: "₹300", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPTsV2UGl4-Uf1aryWtZWYLlnU8LNQWHHtFw&s" },
    ],
  },
  // Waxing
  {
    name: "Waxing",
    subServices: [
      { name: "Full Leg Wax", price: "₹700", img: "https://sumansalon.in/wp-content/uploads/2024/02/5475-2022-11-16.jpg" },
      { name: "Half Leg Wax", price: "₹400", img: "https://5.imimg.com/data5/OU/PL/GLADMIN-32202639/suger-half-leg-waxing-service-500x500.png" },
      { name: "Full Arm Wax", price: "₹500", img: "https://www.personasalon.co.in/wp-content/uploads/2020/05/Full-Arm-Waxing-ua.jpg" },
      { name: "Half Arm Wax", price: "₹300", img: "https://www.personasalon.co.in/wp-content/uploads/2020/05/arms-waxing.jpg" },
      { name: "Underarm Wax", price: "₹250", img: "https://divabeauty.co.nz/cdn/shop/files/underarmwax.jpg?v=1691046373" },
      { name: "Back Wax", price: "₹800", img: "https://purespauk.com/cdn/shop/products/backwax.jpg?v=1634826122&width=1080" },
      { name: "Chest Wax", price: "₹750", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWx5EngD7p0BI-ANn4c0vsDTYfgVAP1kVmQg&s" },
      { name: "Full Body Wax", price: "₹2500", img: "https://faithandpatience.co.in/cdn/shop/articles/7_189f99ce-2af3-4284-a4b2-fe3e971bf942.jpg?v=1753866497&width=1920"},
      { name: "Eyebrow Wax", price: "₹200", img: "https://productimages.withfloats.com/actual/662c70094a71d04d70504c41.jpg" },
    ],
  },
  // Skin Treatment
  {
    name: "Skin Treatment",
    subServices: [
      { name: "Acne Treatment", price: "₹1500", img: "https://www.cozmoderm.com/wp-content/uploads/2022/06/Acne-1.jpeg" },
      { name: "Anti-Aging Treatment", price: "₹2500", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRxgS1wslb_V5FKV8XTCpAl2xSIOSCKGGp1hA&s" },
      { name: "Glow Facial", price: "₹1200", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS-p2Y3r8J0EFbYPWnwhxL8VXWSdUA_ck3hHA&s" },
      { name: "Hydrating Facial", price: "₹1000", img: "https://irp-cdn.multiscreensite.com/698c692a/dms3rep/multi/Benefits-of-a-Hydrating-Facial.png" },
      { name: "Vitamin C Facial", price: "₹1300", img: "https://d2p5rd30inmhrb.cloudfront.net/m2/media/catalog/product/gallery/resized/webp2/vitamincc_2.webp" },
      { name: "Deep Cleansing Facial", price: "₹1100", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSFsUvYlxP6HazicSF00lU5QY0QTv7YJk_ArQ&s" },
      { name: "Brightening Treatment", price: "₹1400", img: "https://ladermaskinclinic.com/wp-content/webp-express/webp-images/uploads/2023/12/skin-1.jpg.webp" },
      { name: "Laser Skin Treatment", price: "₹3000", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZHiKdd8CFjegIjVCw2G-wxgm8kDUJLGwiuQ&s" },
      { name: "Pigmentation Treatment", price: "₹1800", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQniM_qjpzq_2otmbXCOSn8Yu71EzmGgcQLHA&s" },
      { name: "Collagen Facial", price: "₹2000", img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLcYfq6CXnIxTrmS0JJ1pyJjJtdsi9V2cF2g&s" },
    ],
  },
];

export default function Services() {
  const [activeService, setActiveService] = useState(0);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    setFadeIn(true);
  }, [activeService]);

  return (
    <div className="services-page">
      {/* Main Navbar */}
    
      
      

      {/* Special Offer Banner */}
      <div className="special-offer-banner">
        💖 <strong>Festive Offer!</strong> Get <span>20% OFF</span> on Bridal Packages this week! 💄
      </div>

      {/* Services Navbar */}
      <nav className="services-navbar">
        {servicesData.map((service, idx) => (
          <button
            key={idx}
            className={`service-btn ${activeService === idx ? "active" : ""}`}
            onClick={() => setActiveService(idx)}
          >
            {service.name}
          </button>
        ))}
        <div className="underline" style={{ transform: `translateX(${activeService * 120}px)` }} />
      </nav>

      {/* Sub-services */}
      <div className={`sub-services ${fadeIn ? "fade-in" : ""}`}>
        <h2>{servicesData[activeService].name} Packages</h2>
        <p className="service-desc">
          Experience premium {servicesData[activeService].name.toLowerCase()} services with top-quality
          products and expert care designed to rejuvenate your style and confidence.
        </p>
        <div className="sub-services-grid">
          <div className="sub-services-scroll">
            {servicesData[activeService].subServices
              .concat(servicesData[activeService].subServices)
              .map((sub, idx) => (
                <div key={idx} className="sub-service-card">
                  <div className="card-img-wrapper">
                    <img src={sub.img} alt={sub.name} />
                    <div className="overlay">
                      <button className="book-btn">Book Now</button>
                    </div>
                  </div>
                  <div className="sub-service-info">
                    <h3>{sub.name}</h3>
                    <p>{sub.price}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Customer Testimonials */}
      <section className="testimonials fade-in">
        <h2>✨ What Our Clients Say ✨</h2>
        <div className="testimonials-container">
          {[
            { name: "Priya Sharma", text: "Absolutely loved my bridal makeup! The team is super professional and friendly." },
            { name: "Aditi Rao", text: "Their hair spa and manicure service are just amazing. My go-to salon!" },
            { name: "Riya Patel", text: "The ambiance and hygiene are top-notch. Great experience every time!" },
          ].map((t, idx) => (
            <div className="testimonial-card" key={idx}>
              <p>“{t.text}”</p>
              <span>- {t.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Beauty Tips */}
      <section className="beauty-tips">
        <h2> Quick Beauty Tips </h2>
        <ul>
          <li> Stay hydrated for glowing skin.</li>
          <li>Use sunscreen daily to protect your skin.</li>
          <li> Treat your hair with deep conditioning weekly.</li>
          <li> Eat fresh fruits for natural beauty from within.</li>
        </ul>
      </section>

      {/* Footer CTA */}
      <footer className="services-footer">
        <h3>Ready for a Makeover?</h3>
        <button className="cta-btn">Book Your Appointment Now</button>
        <p>© 2025 MySalon — All Rights Reserved</p>
      </footer>
    </div>
  );
}
